import type { Product } from "../Product.js";
import { getProductsCataloguePath } from "./getProductsCataloguePath.js";

export function getProductsCatalogueDetailPath(product: Pick<Product, "urlSlug" | "locale">): string {
	return `${getProductsCataloguePath(product.locale)}/${product.urlSlug}`;
}
